export const sleep = (milliseconds: number) =>
    new Promise<void>((res) => {
        setTimeout(() => {
            res()
        }, milliseconds)
    })
